type SchoolLicense = {
    guid?: string;
    status?: number;
    type?: number;
};

export const getSchoolLicenseSubscriptionGuid = (license: SchoolLicense) =>
    license.type === 0 && license.status === 0 ? license.guid : undefined;

export const getOverlappingSchoolLicenseRows = <T extends SchoolLicense>(
    accountLicenses: readonly (readonly T[])[],
    isValid: (license: T) => boolean
) => {
    const subscriptions = new Map<string, { accounts: number; rows: number }>();

    accountLicenses.forEach(licenses => {
        const accountSubscriptions = new Set<string>();
        licenses.forEach(license => {
            const guid = getSchoolLicenseSubscriptionGuid(license);
            if (!guid || !isValid(license)) return;

            const summary = subscriptions.get(guid) || {
                accounts: 0,
                rows: 0,
            };
            summary.rows += 1;
            if (!accountSubscriptions.has(guid)) {
                summary.accounts += 1;
                accountSubscriptions.add(guid);
            }
            subscriptions.set(guid, summary);
        });
    });

    const subscriptionGuids = new Set<string>();
    let extraRows = 0;
    subscriptions.forEach((summary, guid) => {
        if (summary.accounts < 2) return;
        subscriptionGuids.add(guid);
        extraRows += summary.rows - 1;
    });

    return { subscriptionGuids, extraRows };
};
